export function secondsToTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const sec = (seconds % 60).toString().padStart(2, '0');

  return `${minutes}:${sec}`;
}

interface PastTimestamps {
  sevenDaysAgo: number;
  oneMonthAgo: number;
  oneYearAgo: number;
}

export function getPastTimestamps(now = new Date()): PastTimestamps {
  // Convert the current date to UTC and set the time to 00:00:00.000
  const utcNow = new Date(
    Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      0,
      0,
      0,
      0,
    ),
  );

  return {
    sevenDaysAgo: new Date(
      Date.UTC(
        utcNow.getUTCFullYear(),
        utcNow.getUTCMonth(),
        utcNow.getUTCDate() - 7,
      ),
    ).getTime(),

    oneMonthAgo: new Date(
      Date.UTC(
        utcNow.getUTCFullYear(),
        utcNow.getUTCMonth() - 1,
        utcNow.getUTCDate(),
      ),
    ).getTime(),

    oneYearAgo: new Date(
      Date.UTC(
        utcNow.getUTCFullYear() - 1,
        utcNow.getUTCMonth(),
        utcNow.getUTCDate(),
      ),
    ).getTime(),
  };
}

export function getJsTimestamp(timestamp: number): number {
  if (!timestamp) {
    return timestamp;
  }
  // If the timestamp is less than 10^10, assume it is in seconds.
  return timestamp < 1e10 ? timestamp * 1000 : timestamp;
}

export function getDateByAnyTimestamp(timestamp: number): Date {
  return new Date(getJsTimestamp(timestamp));
}
